// extracted by mini-css-extract-plugin
export default {"container":"zS-z","modal":"AS-z","dimensions":"BS-z","brandName":"CS-z","productName":"DS-z","labelValue":"ES-z","recipientEmail":"FS-z","recommendedFit":"GS-z","hiddenField":"HS-z"};